import { render, staticRenderFns } from "./resumeList.vue?vue&type=template&id=663cc3db&scoped=true"
import script from "./resumeList.vue?vue&type=script&lang=js"
export * from "./resumeList.vue?vue&type=script&lang=js"
import style0 from "./resumeList.vue?vue&type=style&index=0&id=663cc3db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663cc3db",
  null
  
)

export default component.exports